var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H4C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20L2 16C2 15.45 2.19583 14.9792 2.5875 14.5875C2.97917 14.1958 3.45 14 4 14H18C18.55 14 19.0208 14.1958 19.4125 14.5875C19.8042 14.9792 20 15.45 20 16V20ZM4 16V20H18V16H4Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.9V6H14V4H4C3.45 4 2.97917 4.19584 2.5875 4.5875C2.19583 4.97917 2 5.45 2 6V10C2 10.55 2.19583 11.0208 2.5875 11.4125C2.97917 11.8042 3.45 12 4 12L18 12C18.55 12 19.0208 11.8042 19.4125 11.4125C19.8042 11.0208 20 10.55 20 10L4 10V9.9Z",
    fill: "#3DDB69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H22V4H20V2H18V4H16V6L18 6V8H20V6Z",
    fill: "#3DDB69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRow);
export default __webpack_public_path__ + "static/media/add_row.2dc7f2c7f1cce643be666f77b4816712.svg";
export { ForwardRef as ReactComponent };